import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { CheckCircle2, Clock, Loader2, XCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { useLang } from "../../context/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_POLLS = 6;

export const PaymentStatus = () => {
  const { t } = useLang();
  const s = t.payment;
  const [state, setState] = useState(null); // checking | success | pending | cancel
  const polls = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payment = params.get("payment");
    const sessionId = params.get("session_id");
    if (!payment) return;
    window.history.replaceState({}, "", window.location.pathname);
    if (payment === "cancel") { setState("cancel"); return; }
    if (!sessionId) return;
    setState("checking");
    let timer;
    const poll = async () => {
      polls.current += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setState("success"); return; }
        if (["expired", "failed"].includes(data.status)) { setState("cancel"); return; }
      } catch { /* keep polling */ }
      if (polls.current >= MAX_POLLS) { setState("pending"); return; }
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, []);

  const view = {
    checking: { icon: <Loader2 className="h-10 w-10 animate-spin text-[#e8c979]" />, title: s.checking, text: "" },
    success: { icon: <CheckCircle2 className="h-10 w-10 text-[#e8c979]" />, title: s.successTitle, text: s.successText },
    pending: { icon: <Clock className="h-10 w-10 text-[#e8c979]" />, title: s.pendingTitle, text: s.pendingText },
    cancel: { icon: <XCircle className="h-10 w-10 text-white/50" />, title: s.cancelTitle, text: s.cancelText },
  }[state];

  return (
    <Dialog open={!!state} onOpenChange={(o) => !o && setState(null)}>
      <DialogContent data-testid="payment-status-modal" className="max-w-md rounded-[28px] border border-[#d4af37]/25 bg-[#0d0d0f] p-10 text-center text-[#fafaf7] sm:rounded-[28px] [&>button]:text-white/60">
        {view && (
          <>
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-[#d4af37]/30 bg-[#d4af37]/[0.08]">{view.icon}</div>
            <DialogTitle data-testid="payment-status-title" className="mt-6 font-display text-2xl font-bold tracking-tight md:text-3xl">{view.title}</DialogTitle>
            <DialogDescription data-testid="payment-status-text" className="mt-3 text-sm leading-relaxed text-white/60 md:text-base">{view.text}</DialogDescription>
            {state !== "checking" && (
              <button data-testid="payment-status-close" onClick={() => setState(null)} className="btn-ghost mx-auto mt-8">{s.close}</button>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
